/* eslint-disable */
export default {
    inserted: function(el) {

        let winWidth = window.innerWidth;
        let mobileWidth = 500;

        let getMaxHeight = () => {
            let maxHeight = 0;
            const tabPanels = document.querySelectorAll('[role="tabpanel"]');
            console.log("panels: ", tabPanels.length);
            for(let i = 0; i < tabPanels.length; i++) {
                let elHeight = tabPanels[i].offsetHeight;
                console.log(`${i}: ${elHeight}`);
                if(elHeight > maxHeight){
                    maxHeight = elHeight;
                }
            }
            return maxHeight;
        }


        let setMaxHeight = (height) => {
           const tabPanels = document.querySelectorAll('[role="tabpanel"]');
            for(let i = 0; i < tabPanels.length; i++) {
                tabPanels[i].style.height = height + "px";
                
            }
        }

        let reportWindowSize = () => {
            if(winWidth > mobileWidth) {
                setMaxHeight(getMaxHeight());
            }
        }

        console.log("width: ", winWidth);

        setTimeout(() => {
            if(winWidth > mobileWidth) {
                setMaxHeight(getMaxHeight());
            }
            window.addEventListener('resize', reportWindowSize);
        }, 500);

    }
};



// WEBPACK FOOTER //
// ./src/app/directives/max-children-height.js